import BaseObject from '../../../../base/base_object';
import _ from "../../../../utils/underscore";
import Device from '../../../../utils/device/device';
import {LEXIS_NEXIS_CONST} from './lexis_nexis_hybrid_consts';

import {LEXIS_NEXIS, KEY_NAME} from '../../native/native_const';

/**
 *
 *
 */
class LexisNexis extends BaseObject {
    /**
     * @static
     * @type {string}
     */
    static CLASS = 'LexisNexis';
    _HybridService = null;
    _bEnable = false;
    _bLexisNexisSupport = false;
    _bIsDeviceSupportWithAnswer = false;
    _origid = '';
    _server = '';
    _timeout = 0;
    _profilingSessionId = '';
    _startTime = 0;

    init(params) {

        super.init();

        if(_.isNullOrUndefined(params)){
            return;
        }

        this._origid = params.origid;
        this._server = params.server;
        this._timeout = params.timeout;

        if (Device.hybrid.isHybrid) {
            if (Device.os.isIOS) {
                params = params.ios;
            } else if (Device.os.isAndroid) {
                params = params.android;
            }
        }

        if(!_.isNullOrUndefined(params) && params.enable){
            this._bEnable = true;
        }
    }

    initFeatures(hybridSrv) {

        this._HybridService = hybridSrv;

        if(this._bEnable){
            this._HybridService.IsLexisNexisSupported().then(() => {
                this._bLexisNexisSupport = true;
                this.getLexisNexisInfo({}, true);
            });
        }

        return this;
    }


    getLexisNexisInfo(marketingData, bWaitToResponse) {
        if (this._isDeviceNotSupport()) {
            return new Promise((resolve) => {
                resolve(marketingData);
            });
        }

        if (!bWaitToResponse) {
           return this.getProfilingSessionId(marketingData);
        }

        return this._getLexisNexisInfoFromDevics(marketingData);
    }

    _isDeviceNotSupport() {
        return !Device.hybrid.isHybrid || !this._bEnable || !this._bLexisNexisSupport;
    }

    getProfilingSessionId(marketingData){
        return new Promise((resolve) => {
            marketingData = this._mergeMarketingData(marketingData);
            this._sendElasticEvent(LEXIS_NEXIS.SESSION_ID_CALL, 'session id call', this._profilingSessionId);
            resolve(marketingData);
        });
    }

    _getLexisNexisInfoFromDevics(marketingData){

        return new Promise((resolve) => {
            this._startTime = Date.now();

            this._sendElasticEvent(LEXIS_NEXIS.SESSION_ID_REQUEST_SENT, '', 0);

            let data = {[KEY_NAME.LN_ORG_ID]: this._origid, [KEY_NAME.LN_SERVER]: this._server, [KEY_NAME.TIME_OUT]: this._timeout};
            return this._HybridService.getLexisNexisInfo(data).then(data => {

                let end = Date.now();
                let timeinseconds = (end -  this._startTime)/1000;


                this._bIsDeviceSupportWithAnswer = true;
                let action = LEXIS_NEXIS.SESSION_ID_LOAD_OK;
                let label = 'session id load ok';
                let value = '';
                try {
                    let json = _.safeJSONandDecode(data);

                    let error = json[KEY_NAME.ERROR];
                    if (error !== 0) {
                        resolve(marketingData);
                        return;
                    }
                    let datainfo = json[KEY_NAME.DATA];
                    this._profilingSessionId = datainfo[KEY_NAME.LN_SESSION_ID];
                    value = this._profilingSessionId;

                    if(datainfo[KEY_NAME.CLOSE_BY_TIME_OUT]){

                        action = LEXIS_NEXIS.SESSION_ID_CLOSE_BY_TIME_OUT;
                        label = 'close by timeout';
                    }
                }
                catch (e) {
                    action = LEXIS_NEXIS.SESSION_ID_LOAD_ERROR;
                    label = 'Error in parsing';
                    value = value + ' ' + e;
                }

                label = label + ' ' + value;
                value =  timeinseconds;

                this._sendElasticEvent(action, label, value);

                marketingData = this._mergeMarketingData(marketingData);

                resolve(marketingData);
            });
        });

    }

    _mergeMarketingData(marketingData) {
        let output = Object.assign({}, marketingData, {[LEXIS_NEXIS_CONST.PROFILING_SESSION_ID]: this._profilingSessionId});
        return output;
    }

    _sendElasticEvent(action, label, value){
        const dataToSend  = {
            CGPEventCategory: LEXIS_NEXIS.LEXIS_NEXIS_CATEGORY,
            CGPEventAction: action,
            CGPEventLabel: label,
            CGPEventValue: value
        };

        this._HybridService.serviceFactory.structuredLoggingService().getLogger(dataToSend).info();
    }
}


export default LexisNexis;
